import BasicTokenStylizer from './BasicTokenStylizer.js';
export default {
  install(plg) {
    plg.addPlugin('Expression.TokenStylizer', BasicTokenStylizer);
  }
};